export const  GLOBAL_UPDATE_LOCAL_STORAGE_KEY = 'global-update';
export const  isGlobalUpdateOn = () => ((/true/i).test(localStorage.getItem(GLOBAL_UPDATE_LOCAL_STORAGE_KEY)));